import { Route } from "react-router-dom";

import { VIEW_OFFICE_DASHBOARD } from "src/constants";
import { OFFICE_ROUTES } from "src/pages/office/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { OfficeOverview } from "./OfficeOverview.page";

/**
 * Route tree for the office account module, mounted under `/office`.
 * TODO: Replace VIEW_OFFICE_DASHBOARD gating review with a dedicated office account permission when available.
 */
export const officeRoutes = (
  <Route
    path={OFFICE_ROUTES.overview}
    element={<ProtectedRoute permissions={VIEW_OFFICE_DASHBOARD} component={OfficeOverview} />}
  />
);
